import { CookieValueTypes, getCookie } from 'cookies-next';
import { FormikValues } from 'formik';

const addInternalParamsToUrl = (
  url: string,
  params: {
    alwaysIncludeToken?: boolean;
    formikValues?: FormikValues;
    gtmId: string;
    referring: CookieValueTypes;
    landingPage: CookieValueTypes;
    token?: string;
  },
): string => {
  if (!url) {
    return '';
  }

  try {
    const urlObject = new URL(url, window.location.origin);
    const { searchParams } = urlObject;

    if (params.formikValues) {
      searchParams.set('reachOutVia', params.formikValues.reachedOutVia);
      searchParams.set('experiment', params.formikValues.experiment);
      searchParams.set('lang', params.formikValues.language);
    }

    searchParams.set('gtmId', params.gtmId || 'undefined');
    searchParams.set(
      'referring',
      params.referring ? params.referring.toString() : 'undefined',
    );
    searchParams.set(
      'landingPage',
      params.landingPage ? params.landingPage.toString() : 'undefined',
    );
    searchParams.set('origin', window.location.href);
    searchParams.set('country', document.documentElement.lang);

    if (window.Cookiebot) {
      const { consent } = window.Cookiebot;

      if (consent) {
        searchParams.set('cookiesMarketing', consent.marketing?.toString());
        searchParams.set('cookiesNecessary', consent.necessary?.toString());
        searchParams.set('cookiesPreferences', consent.preferences?.toString());
        searchParams.set('cookiesStatistics', consent.statistics?.toString());
      }
    }

    if (params.token || params.alwaysIncludeToken) {
      searchParams.set('token', params.token || 'undefined');
    }

    searchParams.set(
      'customSessionID',
      getCookie('_custom_sessionID')?.toString() || 'undefined',
    );

    return urlObject.toString();
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error, url);
    return url;
  }
};

export default addInternalParamsToUrl;
